import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import {
  resetBasicEndorsementDetails,
  resetEndorsement,
} from "@redux/slices/endorsement";
import { useAppDispatch } from "@redux/hooks";

/**
 * Resets the endorsement flow state and optionally navigates away.
 * @return function taking an optional path to navigate to after resetting
 */
export const useResetEndorsement = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(
    (path?: string) => {
      dispatch(resetEndorsement());
      dispatch(resetBasicEndorsementDetails());

      // TODO: evict endorsement-related Apollo cache fields once the endorsement
      // GraphQL operations exist, e.g.:
      //   client.cache.evict({ id: "ROOT_QUERY", fieldName: "getEndorsement" });

      if (path) {
        navigate(path);
      }
    },
    [dispatch, navigate]
  );
};
